import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Table, Pagination } from "react-bootstrap";
import { BASEAPIURL, token } from "../../env";

const OfficeBearers = () => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    TermYear: "",
    President: "",
    Secretary: "",
    FromDate: "",
    ToDate: "",
  });

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  

  const fetchData = async () => {
    try {
      const response = await fetch(`${BASEAPIURL}/GetAllOfficeBearers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokenData: token }),
      });
      const result = await response.json();
      setData(result?.data || []);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleShow = (item = null) => {
    if (item) {
      setEditingItem(item);
      setFormData({
        TermYear: item.TermYear || "",
        President: item.President || "",
        Secretary: item.Secretary || "",
        FromDate: item.FromDate?.split("T")[0] || "",
        ToDate: item.ToDate?.split("T")[0] || "",
      });
    } else {
      setEditingItem(null);
      setFormData({
        TermYear: "",
        President: "",
        Secretary: "",
        FromDate: "",
        ToDate: "",
      });
    }
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditingItem(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      tokenData: token,
      OfficeBearses: {
        ...formData,
        FromDate: formData.FromDate,
        ToDate: formData.ToDate || null,
      },
    };

    const url = editingItem
      ? `${BASEAPIURL}/UpdateOfficeBearers?OfficeBearersID=${editingItem.OfficeBearersID}`
      : `${BASEAPIURL}/InsertOfficeBearers`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      console.log("Response:", result);
      handleClose();
      fetchData();
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  const pageCount = Math.ceil(data.length / itemsPerPage);
  const paginatedData = data.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 0 && page < pageCount) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Past Management</h2>
      <Button variant="primary" onClick={() => handleShow()}>
        Add Past Management
      </Button>

      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Term Year</th>
            <th>President</th>
            <th>Secretary</th>
            <th>From Date</th>
            <th>To Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((bearer, idx) => (
            <tr key={bearer.OfficeBearersID || idx}>
              <td>{idx}</td>
              <td>{bearer.TermYear}</td>
              <td>{bearer.President}</td>
              <td>{bearer.Secretary}</td>
              <td>{bearer.FromDate?.split("T")[0]}</td>
              <td>{bearer.ToDate?.split("T")[0]}</td>
              <td>
                <Button
                  variant="warning"
                  size="sm"
                  onClick={() => handleShow(bearer)}
                >
                  Edit
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      <Pagination>
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
        {[...Array(pageCount)].map((_, idx) => (
          <Pagination.Item
            key={idx}
            active={idx === currentPage}
            onClick={() => handlePageChange(idx)}
          >
            {idx + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= pageCount - 1} />
      </Pagination>

      {/* Modal */}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{editingItem ? "Edit" : "Add"} Office Bearer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Term Year</Form.Label>
              <Form.Control
                name="TermYear"
                value={formData.TermYear}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>President</Form.Label>
              <Form.Control
                name="President"
                value={formData.President}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Secretary</Form.Label>
              <Form.Control
                name="Secretary"
                value={formData.Secretary}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                name="FromDate"
                value={formData.FromDate}
                onChange={handleChange}
                min="1000-01-01"
                max="9999-12-31"

              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                name="ToDate"
                value={formData.ToDate}
                onChange={handleChange}
                min="1000-01-01"
                max="9999-12-31"

              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {editingItem ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OfficeBearers;
